import { atom, createStore } from 'jotai'

import { AppBreakpoint } from '@makyoapp/makyo-sdk/models/AppBuilder'

export const jotaiStore = createStore()

export const cellBoundsAtom = atom<{ x: number; y: number; width: number; height: number } | null>(null)

export const toolbarAtom = atom<{
  showDevices: boolean
  components: { path: string; component: React.ReactNode }[]
}>({
  showDevices: false,
  components: [],
})

export const editSettingsAtom = atom<{
  device: AppBreakpoint
  settingKey: string
  updatedValues: {
    settingKey: string
    value: any
  }[]
}>({
  device: 'phone',
  settingKey: '',
  updatedValues: [],
})
